import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Button } from '../../../components/common/Button/Button';
import { CheckText } from '../../../components/common/CheckText';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2 } from '../../../styles/FontStyles';
import { useAppSelector } from '../../../app/hooks';

import { ErrorToast, SidebarModal } from '../../../components';
import { WithdrawWallet } from './WithdrawWallet';
import { SelectWallet } from './SelectWallet/SelectWallet';
import { FlipMeWallet } from '../../FlipMeWallet/FlipMeWallet';
import { flipMeGetInfo } from '../../FlipMeWallet/FlipMeWallet.actions';
import { useDispatch } from 'react-redux';
import {
  ConnectWallet,
  ConnectWalletStatus
} from '../../FlipMeWallet/FlipMeBanner';
import { WalletNFTType } from '../../../types/types';
import { getMyHubsPayment } from '../Portfolio.actions';

interface Step2Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  walletAddress: string | undefined;
  walletAddressSign: string;
  connectWallet: () => Promise<void> | any;
  isConnected: boolean;
  setWalletAddressSign: Dispatch<SetStateAction<string>>;
  setWalletAddress: any;
  selectedNFTWallet: any;
  setSelectedNFTWallet: any;
  conectionWalletStep: number;
  setConectionWalletStep: any;
  setOpenModal: any;
}

export const Step2 = ({
  setWithdrawStep,
  walletAddress,
  walletAddressSign,
  connectWallet,
  isConnected,
  setWalletAddressSign,
  setWalletAddress,
  selectedNFTWallet,
  setSelectedNFTWallet,
  conectionWalletStep,
  setConectionWalletStep,
  setOpenModal
}: Step2Props) => {
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [checkbox5, setCheckbox5] = useState(false);
  const [checkbox6, setCheckbox6] = useState(false);
  const [checkbox7, setCheckbox7] = useState(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dispatch = useDispatch();

  const showError = () => ErrorToast('Check all checkboxes');

  const { flipMeStatus, wallets } = useAppSelector((state) => state.wallets);

  const handleCalculate = () => {
    if (checkbox1 === false) return showError();
    if (checkbox2 === false) return showError();
    if (checkbox3 === false) return showError();
    if (checkbox4 === false) return showError();
    if (checkbox5 === false) return showError();
    if (checkbox6 === false) return showError();
    if (checkbox7 === false) return showError();
    if (!walletAddress) return showError();

    setWithdrawStep(WithdrawStepsEnum.FINAL_STEP);
  };

  const flipMeTitle = () => {
    switch (conectionWalletStep) {
      case ConnectWallet.FIRST_STEP:
        return 'Connecting your FlipME wallet';
      case ConnectWallet.SECOND_STEP:
        return 'Confirm in FlipMe app';
      default:
        break;
    }
  };

  const checkDisabledButton = () => {
    if (
      !checkbox1 ||
      !checkbox2 ||
      !checkbox3 ||
      !checkbox4 ||
      !checkbox5 ||
      !checkbox6 ||
      !checkbox7 ||
      !walletAddress
      // selectedNFTWallet.type === WalletNFTType.FLIPME
    ) {
      return true;
    } else if (
      !checkbox1 ||
      !checkbox2 ||
      !checkbox3 ||
      !checkbox4 ||
      !checkbox5 ||
      !checkbox6 ||
      !checkbox7 ||
      (!isConnected && selectedNFTWallet.type === WalletNFTType.METAMASK) ||
      !walletAddress
    ) {
      return true;
    }
  };

  useEffect(() => {
    if (
      selectedNFTWallet.type === WalletNFTType.FLIPME &&
      flipMeStatus === ConnectWalletStatus.CONNECTED
    ) {
      wallets?.map((wallet, i) => {
        if (wallet.isFlipme) {
          setWalletAddress(wallet.address);
        }
      });
    }
  }, []);

  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='12'>
              <IconWarningMark color={color.colors.primary900} size='52' />
            </Icon>
          </Flexed>
        </Flexed>
        <P1 bold center mb='20'>
          STEP 1: SELECT YOUR CRYPTO WALLET
        </P1>
        <P2 bold center mb='20' color={color.colors.error500}>
          IMPORTANT!
        </P2>
        <P2 bold center mb='20'>
          CHOOSE A WALLET THAT SUPPORTS THE <br />
          ERC-721 NON-FUNGIBLE TOKEN STANDARD.
        </P2>
        <P2 bold center mb='20'>
          IF YOU CHOOSE A WALLET THAT DOES NOT SUPPORT THE ABOVE MENTIONED
          STANDARD, YOUR NFT WILL BE LOST FOREVER.
        </P2>

        <SelectWallet
          onChange={(n) => setSelectedNFTWallet(n)}
          value={selectedNFTWallet}
          setWalletAddress={setWalletAddress}
          setWalletAddressSign={setWalletAddressSign}
          setCheckbox1={setCheckbox1}
          setCheckbox2={setCheckbox2}
          setCheckbox3={setCheckbox3}
          setCheckbox4={setCheckbox4}
          setCheckbox5={setCheckbox5}
          setCheckbox6={setCheckbox6}
          setCheckbox7={setCheckbox7}
        />

        <Flexed column center>
          {/* METAMASK */}
          {!isConnected &&
            selectedNFTWallet.type === WalletNFTType.METAMASK && (
              <>
                <Button w='200px' mr='12' onClick={connectWallet}>
                  Connect Your Wallet
                </Button>
              </>
            )}

          {/* FLIPME */}
          {flipMeStatus !== ConnectWalletStatus.CONNECTED &&
            selectedNFTWallet.type === WalletNFTType.FLIPME && (
              <>
                <Button
                  w='200px'
                  onClick={() => {
                    setConectionWalletStep(ConnectWallet.FIRST_STEP);
                    setIsOpen(!isOpen);
                  }}>
                  Connect Your Wallet
                </Button>
              </>
            )}
          {isConnected && selectedNFTWallet.type === WalletNFTType.METAMASK && (
            <Flexed>
              <WithdrawWallet
                walletAddress={walletAddress}
                connectWallet={connectWallet}
                isButtonVisible={true}
                isConnected={isConnected}
                setWalletAddressSign={setWalletAddressSign}
              />
            </Flexed>
          )}
        </Flexed>
      </Box>
      <CheckText
        checked={checkbox1}
        onClick={() => setCheckbox1(!checkbox1)}
        text={
          'I have checked that the wallet I selected supports the ERC-721 NFT STANDARD.'
        }
      />
      <CheckText
        checked={checkbox2}
        onClick={() => setCheckbox2(!checkbox2)}
        text={
          'I declare that I am in full control of the wallet I selected for withdrawal of my Hub NFT.'
        }
      />
      <CheckText
        checked={checkbox3}
        onClick={() => setCheckbox3(!checkbox3)}
        text={
          'I take full responsibility of withdrawing the Hub NFT to the above selected wallet and declare that I fully understand the responsibility of handling my own wallet and the potential dangers of losing my Hub NFT.'
        }
      />
      <CheckText
        checked={checkbox4}
        onClick={() => setCheckbox4(!checkbox4)}
        text={
          'I understand I will keep my Personal Orders (PO) qualification for ranks in the MaVie compensation plan.'
        }
      />
      <CheckText
        checked={checkbox5}
        onClick={() => setCheckbox5(!checkbox5)}
        text={
          'I understand that my Hub NFT will no longer count towards Binary Weekly Cap.'
        }
      />
      <CheckText
        checked={checkbox6}
        onClick={() => setCheckbox6(!checkbox6)}
        text={
          'I understand that I will keep receiving all my rewards from the Hub NFT to the wallet I have selected above.'
        }
      />
      <CheckText
        checked={checkbox7}
        onClick={() => setCheckbox7(!checkbox7)}
        text={
          'I declare that MaVie Global and all its partners have done everything necessary to inform me of the benefits and dangers of handling my own Hub NFT by withdrawing it from my Back-Office.'
        }
      />

      <Button
        mt='20'
        onClick={handleCalculate}
        disabled={checkDisabledButton()}>
        Continue to final step
      </Button>

      <SidebarModal
        isOpen={isOpen}
        setOpen={() => {
          setIsOpen(!isOpen);
          if (conectionWalletStep === ConnectWallet.SECOND_STEP) {
            dispatch(flipMeGetInfo());
            dispatch(getMyHubsPayment());
          }
        }}
        title={flipMeTitle()}
        sidebarWidth={'560px'}>
        <FlipMeWallet
          setStep={setConectionWalletStep}
          step={conectionWalletStep}
          setIsOpen={setIsOpen}
        />
      </SidebarModal>
    </>
  );
};
